import styled, {css} from 'styled-components';

const StyledMissingFieldIndicator = styled.span`
  display: inline-block;

  ${props => {
    const size = props.size;

    if (size === 'medium') {
      return css`
        width: 10px;
        height: 10px;
      `;
    }
    if (size === 'large') {
      return css`
        width: 14px;
        height: 14px;
      `;
    }
    // default to small
    return css`
      width: 6px;
      height: 6px;
    `;
  }}

  border-radius: 50%;
  background: ${props => props.theme.colors.functional_warning};
  vertical-align: middle;
`;

export {
  StyledMissingFieldIndicator
};
